import { render, staticRenderFns } from "./game-data-helper.vue?vue&type=template&id=e82ec3b6&scoped=true"
import script from "./game-data-helper.vue?vue&type=script&lang=js"
export * from "./game-data-helper.vue?vue&type=script&lang=js"
import style0 from "./game-data-helper.vue?vue&type=style&index=0&id=e82ec3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ec3b6",
  null
  
)

export default component.exports